/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const LemanaProLogoSimpleOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeWidth: "var(--i-s-width)",
  d: "M10.5 21.03h9.25c.28 0 .5-.225.5-.5v-9.31a.482.482 0 0 0-.15-.356l-3.39-3.353M8 21.03H4.25c-.28 0-.5-.224-.5-.5v-9.31c0-.134.05-.26.15-.354l7.74-7.748a.5.5 0 0 1 .71.003l2.46 2.491"
})));
// Fill
const LemanaProLogoSimpleFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M11.2 2.675c.44-.44 1.16-.44 1.6 0l1.77 1.778c.39.389.39 1.019.01 1.41-2.1 2.12-4.2 4.241-6.29 6.357a.98.98 0 0 0-.29.704v7.732c0 .552-.45 1-1 1H4.25a1.13 1.13 0 0 1-1.13-1.125V11.22c0-.299.12-.586.33-.796l7.75-7.75zm-.7 14.337c-.55 0-1 .448-1 1v2.643c0 .552.45 1 1 1h9.25c.62 0 1.13-.504 1.13-1.125v-9.31c0-.299-.12-.586-.33-.796l-3.44-3.433a1.003 1.003 0 0 0-1.42.003l-1.97 1.995a.997.997 0 0 0 .03 1.44l2.1 1.93c.1.088.15.207.15.33v3.858c0 .257-.23.466-.51.466H10.5z"
})));
// DuoTone
const LemanaProLogoSimpleDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.25 20.53v-9.31c0-.134-.05-.26-.15-.354l-7.75-7.75a.49.49 0 0 0-.7 0l-7.75 7.75c-.1.094-.15.22-.15.354v9.31c0 .276.22.5.5.5h15.5c.28 0 .5-.224.5-.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeWidth: "var(--i-s-width)",
  d: "M10.5 21.03h9.25c.28 0 .5-.224.5-.5v-9.309a.482.482 0 0 0-.15-.355l-3.39-3.353M8 21.03H4.25c-.28 0-.5-.224-.5-.5v-9.31c0-.134.05-.26.15-.354l7.74-7.747a.5.5 0 0 1 .71.002l2.46 2.492"
})));
/**
  Icon LemanaProLogoSimpleIcon in brands group
*/
export const LemanaProLogoSimpleIcon = createIcon('LemanaProLogoSimpleIcon', 'lemana-pro-logo-simple', 'brands', LemanaProLogoSimpleOutline, LemanaProLogoSimpleFill, LemanaProLogoSimpleDuotone, "0 0 24 24");